var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"_userWrapper"},[_c('div',{class:{_image:true, dark:_vm.dark},style:(( _obj = {}, _obj['background-image'] = _vm.image != null?("url(" + _vm.image + ")"):null, _obj ))},[_c('ripple'),_c('div',{staticClass:"_char"},[_vm._v(_vm._s(_vm.name?_vm.name.charAt(0):null))])],1)])
var _obj;}
var staticRenderFns = []

export { render, staticRenderFns }